export default {
  overrideRequest: function (axiosConfig) {

  },

  oldgetauthtoken: {
    overrideRequest: function (axiosConfig) {
      console.log('oldgetauthtoken overrideRequest', axiosConfig)
      axiosConfig.method = 'post'
      // axiosConfig.url = axiosConfig.url.replace('clientapi', 'removeinproduction')
      // axiosConfig.url = axiosConfig.url.replace('wishbetclient/', '')
    }
  },
  getauthtoken: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  savewishbet: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  getwishbet: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  deletewishbet: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/WishBetClient.js